import { render, staticRenderFns } from "./OrderIntro.vue?vue&type=template&id=869e1902&scoped=true&"
import script from "./OrderIntro.vue?vue&type=script&lang=babel&"
export * from "./OrderIntro.vue?vue&type=script&lang=babel&"
import style0 from "./OrderIntro.vue?vue&type=style&index=0&id=869e1902&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e1902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
